import NetworkCall from "network/networkCall";
import Request from "network/request";

export default class ClientWorkflow {
  static async getSummary(clientId) {
    return NetworkCall.fetch(
      Request.v2.getClientWorkflowSummary(clientId),
      false,
      false,
    );
  }

  static async getTransitions(clientId) {
    return NetworkCall.fetch(
      Request.v2.getClientWorkflowTransitions(clientId),
      false,
      false,
    );
  }

  static async getStatuses(clientId) {
    return NetworkCall.fetch(Request.v2.getClientWorkflowStatuses(clientId));
  }

  static async getWorkflowData(clientId) {
    return Promise.all([
      this.getSummary(clientId),
      this.getTransitions(clientId),
    ]);
  }

  static async updateSubStatus(clientId, subStatusId, data) {
    return NetworkCall.fetch(
      Request.v2.updateClientWorkflowSubStatus(clientId, subStatusId, data),
      true,
      false,
    );
  }

  static async updateTransition(clientId, transitionId, data) {
    return NetworkCall.fetch(
      Request.v2.updateClientWorkflowTransition(clientId, transitionId, data),
      true,
      false,
    );
  }

  static async updateCustomTransition(clientId, customTransitionId, data) {
    return NetworkCall.fetch(
      Request.v2.updateClientWorkflowCustomTransition(
        clientId,
        customTransitionId,
        data,
      ),
      true,
      false,
    );
  }

  static async updateStatusPosition(clientId, statusId, data) {
    return NetworkCall.fetch(
      Request.v2.updateClientWorkflowStatusPosition(clientId, statusId, data),
      true,
      false,
    );
  }
}
